import { BookMarkedIcon, ClipboardCheckIcon, FlaskConicalIcon, FolderOpenIcon, LayersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades y Prácticas de Geología',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre minerales, rocas, tectónica, sismos, volcanes, geomorfología, fósiles, tiempo geológico, agua subterránea y recursos. Organizadas por nivel de dificultad.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluaciones de Geología',
    description:
      'Evaluaciones diagnósticas, actividades de seguimiento, preguntas de opción múltiple, verdadero/falso, respuestas breves, desarrollo, casos prácticos, evaluaciones integradoras, rúbricas y criterios de evaluación. Todo incluido directamente dentro del PDF.',
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: 'Banco de 100 Casos y Situaciones Problemáticas de Geología',
    description:
      '100 casos organizados por áreas temáticas para analizar evidencias, formular hipótesis, interpretar procesos geológicos y resolver situaciones. Desde casos simples hasta desafíos integrados.',
    benefit: 'Tus alumnos aprenden analizando situaciones reales de geología.',
    value: 'USD 14',
    icon: LayersIcon,
  },
  {
    number: '04',
    title: 'Laboratorio de Geología — 60 Prácticas y Experiencias Seguras para el Aula',
    description:
      '60 experiencias sobre identificación de minerales, clasificación de rocas, meteorización, erosión, sedimentación, tectónica, sismos, volcanismo, estratigrafía, fósiles y agua subterránea. Todas con materiales accesibles y procedimientos seguros.',
    benefit: 'Tus alumnos aprenden haciendo de forma segura.',
    value: 'USD 14',
    icon: FlaskConicalIcon,
  },
  {
    number: '05',
    title: 'Guía de 200 Conceptos Clave, Errores Frecuentes y Explicaciones Didácticas de Geología',
    description:
      '200 conceptos fundamentales explicados para el docente, con los errores frecuentes que cometen los alumnos, aclaraciones, ejemplos didácticos, preguntas de comprobación y conexiones entre conceptos.',
    benefit: 'Proyéctalo en clase y tus alumnos entienden de inmediato cómo funciona cada concepto.',
    value: 'USD 14',
    icon: BookMarkedIcon,
    wide: true,
  },
];
